import { render, staticRenderFns } from "./HubBiodata.vue?vue&type=template&id=16dbbe9f"
import script from "./HubBiodata.vue?vue&type=script&lang=js"
export * from "./HubBiodata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports